import { useMemo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Platform } from 'react-native';
import { useTheme } from '../useTheme';
export const useSnapPoints = () => {
    const { bottom } = useSafeAreaInsets();
    const { miniplayerHeight, navBarHeight } = useTheme();
    const tabBarHeight = navBarHeight + bottom;
    const zero = Platform.OS === 'web' ? miniplayerHeight : (miniplayerHeight + tabBarHeight);
    return useMemo(() => [
        zero,
        '100%',
    ], [
        tabBarHeight,
    ]);
};
//# sourceMappingURL=useSnapPoints.js.map